import ClickOutside from '@/directives/clickOutside'

export default {
  props: {
  /**
   * @model
   */
    value: {
      type: [Boolean, String],
      default: false
    }
  },
  data () {
    return {
      show: JSON.parse(this.value)
    }
  },
  directives: {
    ClickOutside
  },
  beforeMount () {
    this.$nextTick(() => {
      document.addEventListener('keydown', this.closeOnEsc)
    })
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.closeOnEsc)
  },
  methods: {
    onClickOutside () {
      this.close()
    },
    on () {
      this.show = !this.show
    },
    close () {
      this.show = false
    },
    closeOnEsc (event) {
      if (this.unclosable) {
        return
      }
      if (event.keyCode === 27) {
        this.close()
      }
    }
  },
  watch: {
    show (newVal) {
      this.$emit('input', JSON.parse(newVal))
    },
    value (newVal) {
      this.show = JSON.parse(newVal)
    }
  }
}
